import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "分类", path: "/category/all" },
  { name: "排行榜", path: "/category/all" },
  { name: "无遮挡韩漫", path: "/category/all" },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="text-2xl font-black tracking-tighter text-primary-500 font-heading">
              汗汗<span className="text-foreground-900">漫画</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? "text-primary-500 bg-primary-50"
                    : scrolled
                    ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50"
                    : "text-white/90 hover:text-white hover:bg-white/10"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-600 hover:text-primary-500 hover:bg-background-100"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
              aria-label="搜索漫画"
            >
              <i className="ri-search-line text-lg"></i>
            </button>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer text-white/80 hover:text-white hover:bg-white/10"
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className={`pb-3 ${scrolled ? "" : "bg-black/20 rounded-b-lg"}`}>
            <div className="relative max-w-md mx-auto">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索你喜欢的漫画..."
                className="w-full pl-10 pr-4 py-2.5 rounded-full bg-background-50/90 border border-background-200 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
          </div>
        )}
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <nav className="flex flex-col py-2 px-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? "text-primary-500 bg-primary-50"
                    : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}